import { stateToHTML } from 'draft-js-export-html'
import { EditorState, convertFromRaw } from 'draft-js'

export const parseDescriptionToHtml = (
  description: string | undefined,
): string => {
  try {
    if (!description) return ''

    const jsonParsedDescription = JSON.parse(description)

    const editorStateDescription = EditorState.createWithContent(
      convertFromRaw(jsonParsedDescription),
    )

    const htmlParsedDescription = stateToHTML(
      editorStateDescription.getCurrentContent(),
    )

    return htmlParsedDescription
  } catch {
    return description || ''
  }
}
